export default __webpack_public_path__ + "static/welfare-video-0aaf4e61aba2a12f62a153d0d7e2e62a.jpg";